import { range } from 'lodash';
import React, { Component } from 'react';
import JSONTree from '@splunk/react-ui/JSONTree';
import Table from '@splunk/dashboard-visualizations/Table';
import Heading from '@splunk/react-ui/Heading';

class RequestParams extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            requestParams: {
                count: 10,
                offset: 0,
            },
        };
    }

    handleRequestParams = (type, newRequestParams) => {
        this.setState({
            requestParams: newRequestParams,
        });
    };

    render() {
        const { requestParams } = this.state;
        const dataSources = {
            primary: {
                requestParams,
                data: {
                    fields: [{ name: 'foo' }, { name: 'bar' }],
                    columns: [
                        range(requestParams.offset, requestParams.offset + 10),
                        range(requestParams.offset, requestParams.offset + 10),
                    ],
                },
                meta: { totalCount: 200 },
            },
        };
        return (
            <div>
                <div>
                    <Heading level={4}>RequestParams</Heading>
                    <JSONTree json={requestParams} expandChildren />
                </div>
                <Table
                    options={{}}
                    encoding={{
                        columns: ['primary.foo', 'primary.bar'],
                    }}
                    dataSources={dataSources}
                    onRequestParamsChange={this.handleRequestParams}
                />
            </div>
        );
    }
}

export default RequestParams;
